(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1'; root.hidden = false;
    var panel = root.querySelector('[data-fxai-panel]');
    var launcher = root.querySelector('[data-fxai-open]');
    var close = root.querySelector('[data-fxai-close]');
    var form = root.querySelector('[data-fxai-form]');
    var input = root.querySelector('[data-fxai-input]');
    var messages = root.querySelector('[data-fxai-messages]');
    var quick = root.querySelector('[data-fxai-quick]');
    var history = [];
    function toggle(open) {
      panel.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(function () { input.focus(); }, 80);
    }
    function add(text, who) {
      var div = document.createElement('div');
      div.className = 'fxai__msg fxai__msg--' + who;
      div.textContent = text;
      messages.appendChild(div); messages.scrollTop = messages.scrollHeight;
      return div;
    }
    function send(text) {
      text = (text || '').trim(); if (!text || form.dataset.busy) return;
      add(text, 'user'); history.push({ role: 'user', text: text });
      input.value = ''; quick.hidden = true; form.dataset.busy = '1';
      var wait = add('Estoy consultándolo…', 'bot'); wait.classList.add('is-waiting');
      fetch((root.dataset.api || '') + '/api/public/chat', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, history: history.slice(-12, -1) })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (result) {
          wait.remove();
          var reply = result.ok && result.data.reply ? result.data.reply :
            (result.data.error || 'No puedo responder ahora. Escríbenos por WhatsApp.');
          add(reply, 'bot'); history.push({ role: 'assistant', text: reply });
        }).catch(function () {
          wait.remove(); add('No puedo responder ahora. Escríbenos por WhatsApp.', 'bot');
        }).finally(function () { delete form.dataset.busy; input.focus(); });
    }
    launcher.addEventListener('click', function () { toggle(!panel.classList.contains('is-open')); });
    close.addEventListener('click', function () { toggle(false); });
    form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(input.value); }
    });
    quick.addEventListener('click', function (e) { if (e.target.tagName === 'BUTTON') send(e.target.textContent); });
  }
  document.querySelectorAll('[data-fxai]').forEach(init);
}());
